import AdditionalLinks from '~/shared/components/header/components/additional-links';
import useIconToggle from '~/shared/components/header/components/icon-toggle/use-icon-toggle';
import MenuIcon from '~/shared/components/header/components/menu-icon';

import './icon-toggle.scss';

const IconToggle = ({ lng }) => {
  const { openAdditionalLinks, scheduleCloseAdditionalLinks, closeDropdown, isAdditionalLinksOpen } = useIconToggle();

  return (
    <div className="icon-toggle" onMouseEnter={openAdditionalLinks} onMouseLeave={scheduleCloseAdditionalLinks}>
      <div className="icon-toggle__additional-menu-icon">
        <MenuIcon />
      </div>
      {isAdditionalLinksOpen ? (
        <div
          className="icon-toggle__additional-links-dropdown icon-toggle__blog-items"
          onMouseEnter={openAdditionalLinks}
          onMouseLeave={scheduleCloseAdditionalLinks}
        >
          <div className="icon-toggle__additional-links-dropdown-inner">
            <AdditionalLinks closeDropdown={closeDropdown} lng={lng} />
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default IconToggle;
